import React from "react";
import "../styles/contactUs.css";



const ContactUs: React.FC = () => {
    return (
        <section className="">
        </section>
    );
};

export default ContactUs;
